import { Box, Icon } from "@chakra-ui/react";
import React from "react";
import { type BadgeProps } from "./types";

export function Soc2Badge({ backgroundColor, foregroundColor, ...props }: BadgeProps) {
  return (
    <Icon width="112" height="112" viewBox="0 0 112 112" fill="none" {...props}>
      <Box
        as="path"
        d="M111.321 56.016c0 30.556-24.771 55.328-55.328 55.328-30.557 0-55.329-24.772-55.329-55.328C.664 25.459 25.436.688 55.993.688c30.557 0 55.328 24.77 55.328 55.328Z"
        fill={backgroundColor}
      />

      <Box as="g" fill={foregroundColor}>
        <Box
          as="path"
          d="M32.295 51.523h-2.33l5.143-12.938h2.401l5.09 12.938h-2.33l-1.2-3.19h-5.574l-1.2 3.19Zm2.168-5.734-.287.753h4.212l-.287-.753c-.592-1.505-1.577-4.175-1.792-4.838h-.036c-.215.663-1.326 3.548-1.81 4.838Zm9.109 5.734V38.585h2.15v12.938h-2.15Zm10.4.34c-3.764 0-6.506-2.795-6.506-6.79 0-3.997 2.778-6.828 6.577-6.828 2.813 0 5.071 1.577 5.86 4.068l-2.025.896c-.43-1.918-1.935-3.011-3.853-3.011-2.545 0-4.319 1.9-4.319 4.856 0 2.957 1.774 4.857 4.337 4.857 1.935 0 3.387-1.093 3.835-2.993l2.007.878c-.77 2.545-3.154 4.068-5.914 4.068Zm9.741-.34h-2.15V38.585H66.4c3.154 0 4.946 1.47 4.946 4.05 0 2.616-1.846 4.14-5 4.14h-2.634v4.748Zm2.545-11.002h-2.545v4.318h2.598c1.918 0 2.886-.734 2.886-2.186 0-1.398-1.004-2.132-2.94-2.132Zm5.85 11.002H69.78l5.143-12.938h2.401l5.09 12.938h-2.33l-1.2-3.19h-5.574l-1.2 3.19Zm2.169-5.734-.287.753h4.211l-.286-.753c-.592-1.505-1.577-4.175-1.792-4.838h-.036c-.215.663-1.326 3.548-1.81 4.838Z"
        />
        <Box
          as="path"
          d="M42.717 73.824c-2.885 0-5.125-1.56-5.447-3.925l2.096-.734c.18 1.648 1.577 2.777 3.37 2.777 1.54 0 2.598-.806 2.598-2.007 0-1.057-.753-1.577-1.954-1.846l-1.97-.448c-2.402-.537-3.567-1.845-3.567-3.691 0-2.24 1.918-3.745 4.749-3.745 2.652 0 4.587 1.326 4.946 3.35l-2.097.771c-.107-1.344-1.29-2.24-2.92-2.24-1.398 0-2.366.681-2.366 1.685 0 .86.663 1.415 1.684 1.648l2.276.538c2.115.502 3.495 1.649 3.495 3.727 0 2.455-1.954 4.14-4.893 4.14Zm12.244 0c-3.8 0-6.541-2.831-6.541-6.81 0-3.978 2.724-6.81 6.54-6.81 3.818 0 6.541 2.832 6.541 6.81 0 3.979-2.723 6.81-6.54 6.81Zm0-1.953c2.562 0 4.318-1.99 4.318-4.857s-1.756-4.856-4.319-4.856c-2.562 0-4.3 1.99-4.3 4.856 0 2.868 1.756 4.857 4.3 4.857Zm14.06 1.953c-3.763 0-6.505-2.796-6.505-6.792s2.778-6.827 6.577-6.827c2.813 0 5.071 1.577 5.86 4.067l-2.025.896c-.43-1.917-1.935-3.01-3.853-3.01-2.545 0-4.319 1.9-4.319 4.856 0 2.957 1.774 4.857 4.337 4.857 1.935 0 3.387-1.093 3.835-2.993l2.007.878c-.77 2.545-3.154 4.068-5.914 4.068Z"
        />
      </Box>

      <Box as="g" stroke={foregroundColor}>
        <Box
          as="path"
          d="M103.604 56.016c0 26.288-21.311 47.599-47.6 47.599s-47.6-21.31-47.6-47.6c0-26.288 21.311-47.6 47.6-47.6s47.6 21.312 47.6 47.6Z"
          strokeWidth="1.12"
        />
        <Box as="path" d="M30.055 56.004h53" strokeWidth="1.12" />
      </Box>
    </Icon>
  );
}
